<div class="banner">
  <div>
    <div
      class="banner-title typography typography-h1 green-basic typography-bold"
    >
      Знакомьтесь: Helix Express
    </div>
    <div class="banner-text typography typography-h1">
      Сдавайте анализы со скидкой до&nbsp;{{ Discount.Amount
      }}{{ Discount.UnitMeasurement }}
    </div>

    <div class="banner-profit typography typography-h4">
      Получайте результаты в тот же день
    </div>

    <div class="typography typography-headline banner-app-title">
      Установите приложение:
    </div>

    <div class="mb-64">
      <app-mobile-apps-links
        [googlePlayLink]="HelixExpressMobileApp.autodetectStoreLinkExpress"
        [appleStoreLink]="HelixExpressMobileApp.autodetectStoreLinkExpress"
        [appGalleryLink]="''"
      >
      </app-mobile-apps-links>
    </div>
  </div>

  <picture class="banner-wrapper-image">
    <source [srcset]="images.labomatBannerWebp" type="image/webp" />
    <img
      width="457"
      height="474"
      class="banner-image"
      alt=""
      loading="lazy"
      decoding="auto"
      [src]="images.labomatBannerPng"
    />
  </picture>
</div>
